<template>
  <router-view></router-view>
</template>
<script>
import { notificationMixin } from "@/mixins/notification";
import $ from 'jquery'
export default {
  name: "App",
  mixins: [notificationMixin],
  data() {
    return {
      locationClasses: "messenger-fixed messenger-on-top messenger-on-center"
    };
  },
  methods: {
    reportKeyEvent(zEvent) {
      var keyStr = ["Control", "Shift", "Alt"].includes(zEvent.key)
        ? ""
        : zEvent.key + " ";
      var reportStr =
        (zEvent.ctrlKey ? "Control/" : "") +
        (zEvent.shiftKey ? "Shift/" : "") +
        (zEvent.altKey ? "Alt/" : "") +
        keyStr;
      if (typeof this.$AppDetails != "undefined") {
        //  to show the shorcutmodal
        if ($.trim(keyStr) == "?") {
          this.$root.$emit("bv::show::modal", "shortcutkey");
        } else if (
          typeof this.$AppDetails.shortcut_keys[$.trim(reportStr)] !=
          "undefined"
        ) {
          //  to move valid router
          this.$router.push({
            name: this.$AppDetails.shortcut_keys[$.trim(reportStr)]
          });
          //  hide the shortcut key modal if exists
          this.$root.$emit("bv::hide::modal", "shortcutkey");
        }
      }
      //  stop once happen
      zEvent.stopPropagation();
      zEvent.preventDefault();
    }
  },
  created() {
    this.initializationMessengerCode();
    window.Messenger.options = {
      extraClasses: this.locationClasses,
      theme: "air"
    };
  },
  mounted: function() {
    this.$nextTick(function() {
      window.addEventListener("keyup", event => {
        var self = this;
        //  check for pressed key not inside the input, text area and select based fields
        switch (event.target.tagName) {
          case "INPUT":
          case "SELECT":
          case "TEXTAREA":
          case "DIV":
            return;
          default:
            self.reportKeyEvent(event);
        }
      });
    });
  },
  updated() {
    if (this.network_error == 500) {
      window.Messenger().post({
        extraClasses: "messenger-fixed messenger-on-top messenger-on-center",
        message: "Please check your internet connection !",
        type: "danger",
        showCloseButton: true
      });
      this.network_error = "";
    }
  },
  computed: {
    // to udpate the network error details tab
    network_error: {
      get() {
        return this.$store.state.general.network_error;
      },
      set(val) {
        this.$store.state.general.network_error = val;
      }
    }
  }
};
</script>

<style src="./styles/theme.scss" lang="scss" />
